import { HuitabConstantes } from '../../shared/enums/huitab-constantes.enum.js';
import { StoreKeys } from '../../shared/enums/store-keys.enum.js';
import { PageManager } from '../../shared/services/page-manager.js';
import { huitabSettings, PageTypes } from '../../shared/services/settings-loader.js';
import { StoreManager } from '../../shared/services/store-manager.js';
import { ModalConfirmationImportInterlocuteurs } from './modals/confirmation-import-interlocuteurs/modal-confirmation-import-interlocuteurs.js';
import { ModalConfirmationTelechargementInterlocuteurs } from './modals/confirmation-telechargement-interlocuteurs/modal-confirmation-telechargement-interlocuteurs.js';

require('../../core/require.js');
require('./page.css');

export const modalConfirmationImportInterlocuteurs = new ModalConfirmationImportInterlocuteurs();
export const modalConfirmationTelechargementInterlocuteurs = new ModalConfirmationTelechargementInterlocuteurs();

// On vérifie la page affichée car les js de toutes les pages sont joués au lancement du portail où qu'on soit - alors qu'on ne veut afficher le bloc erreur que sur cette page.
if ( PageManager.current === PageTypes.GESTION_INTERLOCUTEURS_EN_MASSE &&
  (!huitabSettings.feature_flipping.interlocuteurs_unitaire_et_masse ||
    !huitabSettings.feature_flipping.interlocuteurs_masse)
) {
  PageManager.afficherBlocErreurTechnique();
} else {
  StoreManager.subscribe(StoreKeys.SELECTED_SIREN, _displayOnSelectedSirenChanged.bind(this));
}

function _displayOnSelectedSirenChanged(siren) {
  if (StoreManager.selectedSiren === HuitabConstantes.SIREN_ALL) {
    afficherSelectionCollectivite();
  } else {
    afficherPageGestionInterlocuteursEnMasse();
  }
}

function afficherSelectionCollectivite() {
  afficherPage(['veuillez-selectionner-collectivite']);
}

function afficherPageGestionInterlocuteursEnMasse() {
  const perimetreCourant = StoreManager.perimetre.find((el) => el.siren === StoreManager.selectedSiren);

  if (perimetreCourant.fonctionnalites.includes('INFO_COUPURES')) {
    afficherPage(['bloc-gestion-interlocuteurs-en-masse']);
  } else {
    afficherFonctionnaliteInaccessible();
  }
}

function afficherFonctionnaliteInaccessible() {
  if (StoreManager.isMultiCollectivites) {
    afficherPage(['fonctionnalite-inaccessible-multi']);
  } else {
    afficherPage(['fonctionnalite-inaccessible-mono']);
  }
}

/**
 * @typedef {"fonctionnalite-inaccessible-mono"|"fonctionnalite-inaccessible-multi"|"bloc-gestion-interlocuteurs-en-masse"|"veuillez-selectionner-collectivite"} BlocGestionInterlocuteursId
 */

/**
 * Affiche les blocs HTML correspondant aux identifiants spécifiés et masque les autres blocs prédéfinis.
 *
 * @param {Array<BlocGestionInterlocuteursId>} [ids=[]]
 *   Tableau d'identifiants de blocs à afficher. (Les valeurs possibles sont uniquement celles définies dans l'array `blocs`).
 */
function afficherPage(ids = []) {
  /** @type {Array<BlocGestionInterlocuteursId>} */
  const blocs = [
    'fonctionnalite-inaccessible-mono',
    'fonctionnalite-inaccessible-multi',
    'bloc-gestion-interlocuteurs-en-masse',
    'veuillez-selectionner-collectivite',
  ];

  blocs.forEach((id) => {
    const bloc = document.getElementById(id);
    if (bloc) bloc.hidden = true;
  });

  ids.forEach((id) => {
    const blocAAfficher = document.getElementById(id);
    if (blocAAfficher) blocAAfficher.hidden = false;
  });
}
